import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { ScientificNumberInput } from '@instructure/quiz-number-input';
import { omitProps } from '@instructure/ui-react-utils';

// Wraps ScientificNumberInput, replacing the onChange and onBlur
// props with a single onUpdate handler that only fires on blur.
var VariableInput = /*#__PURE__*/function (_React$Component) {
  function VariableInput(props) {
    var _this;
    _classCallCheck(this, VariableInput);
    _this = _callSuper(this, VariableInput, [props]);
    _defineProperty(_this, "handleBlur", function () {
      if (_this.state.normalized === null) {
        _this.setState(_this.stateFromProps());
      } else if (_this.state.normalized != _this.props.value) {
        // intentional double-equals
        _this.props.onUpdate(_this.state.normalized);
      }
    });
    _defineProperty(_this, "handleChange", function (event, value, normalized) {
      _this.setState({
        value: value,
        normalized: normalized
      });
    });
    _this.state = _this.stateFromProps(props);
    return _this;
  }
  _inherits(VariableInput, _React$Component);
  return _createClass(VariableInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState(this.stateFromProps(nextProps));
    }
  }, {
    key: "stateFromProps",
    value: function stateFromProps() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      return {
        value: props.value,
        normalized: props.value
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ScientificNumberInput, Object.assign({}, omitProps(this.props, this.constructor.propTypes), {
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        showArrows: false,
        value: this.state.value
      }));
    }
  }]);
}(React.Component);
_defineProperty(VariableInput, "propTypes", {
  onUpdate: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});
_defineProperty(VariableInput, "defaultProps", {
  value: void 0
});
export { VariableInput as default };